import { jmrSquaredAttribution } from '../config/attribution';
import { demoPreview } from '../config/demo-preview';

export function JmrSquaredAttribution() {
  return (
    <aside
      className="border-t border-neutral-200 bg-surface px-4 py-5 sm:px-6 lg:px-8"
      aria-label="Website attribution"
    >
      <div className="mx-auto flex max-w-7xl flex-col gap-3 font-body text-base leading-7 text-neutral-600">
        <p className="max-w-[68ch] text-neutral-600">{demoPreview.attributionContext}</p>
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <p>
            {jmrSquaredAttribution.creditLabel}{' '}
            <a
              href={jmrSquaredAttribution.studioUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-11 items-center font-medium text-ink underline decoration-neutral-300 underline-offset-4 transition-[text-decoration-color] duration-200 ease-in-out hover:decoration-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink"
            >
              {jmrSquaredAttribution.studioName}
            </a>
            {' · '}
            <a
              href={jmrSquaredAttribution.studioUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-11 items-center underline decoration-neutral-300 underline-offset-4 transition-[text-decoration-color] duration-200 ease-in-out hover:decoration-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink"
            >
              tech.jmrsquared.com
            </a>
          </p>
          <p>
            {jmrSquaredAttribution.similarSiteMessage}{' '}
            <a
              href={jmrSquaredAttribution.contactMailto}
              className="inline-flex min-h-11 items-center font-medium text-ink underline decoration-neutral-300 underline-offset-4 transition-[text-decoration-color] duration-200 ease-in-out hover:decoration-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink"
            >
              {jmrSquaredAttribution.contactEmail}
            </a>
          </p>
        </div>
      </div>
    </aside>
  );
}
